import(/* webpackMode: "eager" */ "/opt/build/repo/apps/hestia/src/app/global-error.tsx");
